import React from "react";
import { Panel, StateChip } from "@/components/ldc01/Ldc01Ui";

export function VerifyStep({ gates }) {
  const passed = gates.filter((x) => x.state === "PASS").length;
  return (
    <div className="space-y-5" data-testid="ldc01-verify-step">
      <Panel title="Verification gates"
        subtitle="Every gate is mandatory. Status is taken only from server evidence; missing evidence is shown as PENDING or NOT VERIFIED, never PASS.">
        <div className="text-xs font-mono text-zinc-400 mb-3" data-testid="ldc01-gates-summary">{passed} / {gates.length} gates PASS</div>
        <ul className="divide-y divide-[var(--border)]">
          {gates.map((x, i) => (
            <li key={x.key} className="py-3 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4" data-testid={`ldc01-gate-${x.key}`}>
              <span className="font-mono text-[11px] text-zinc-500 w-6 shrink-0">{String(i + 1).padStart(2, "0")}</span>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-white font-medium">{x.label}</div>
                <div className="text-xs text-zinc-500 mt-0.5 break-words" data-testid={`ldc01-gate-${x.key}-evidence`}>{x.evidence}</div>
              </div>
              <StateChip state={x.state} testId={`ldc01-gate-${x.key}-state`} />
            </li>
          ))}
        </ul>
      </Panel>
    </div>
  );
}
